import useSWRMutation from 'swr/mutation';
import { useSelector } from 'react-redux';
import postOnboarding from '../api/postOnboarding';
import { createOnboardingRequest } from './onboardingFormHelper';
const useOnboarding = () => {
  const baseUrl = useSelector(state => state.getIn(['config', 'invoiceManagementApiUrl']));
  const {
    trigger,
    isMutating,
    error,
    data,
    reset
  } = useSWRMutation(baseUrl ? `${baseUrl}/v1/buyers` : null, postOnboarding);
  const handleSubmit = async formValues => {
    const request = createOnboardingRequest({
      formValues
    });
    await trigger(request);
  };
  return {
    handleSubmit,
    isLoading: isMutating,
    isOnboardingError: !!error,
    onboardingError: error,
    isOnboardingSuccess: !!data,
    dismissNotification: reset
  };
};
export default useOnboarding;